window.addEventListener('load', function(event) {
    window.addEventListener("scroll", scrollHandler);
});

var is25ScrollFired = false;
var is50ScrollFired = false;
var is75ScrollFired = false;
var is100ScrollFired = false;

function scrollHandler() {
    var scrollTop = window.scrollY;
    var scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
    var scrollPercent = scrollTop / scrollHeight;
    var scrollPercentRounded = Math.round(scrollPercent*100);

    if (!is25ScrollFired && scrollPercentRounded > 25 && scrollPercentRounded < 50) {
        Shopify.analytics.publish("pageScroll", {percent: 25});
        is25ScrollFired = true;
    }
    else if (!is50ScrollFired && scrollPercentRounded >= 50 && scrollPercentRounded < 75) {
        Shopify.analytics.publish("pageScroll", {percent: 50});
        is50ScrollFired = true;
    }
    else if (!is75ScrollFired && scrollPercentRounded >= 75 && scrollPercentRounded < 100) {
        Shopify.analytics.publish("pageScroll", {percent: 75});
        is75ScrollFired = true;
    }
    else if (!is100ScrollFired && scrollPercentRounded >= 100) {
        Shopify.analytics.publish("pageScroll", {percent: 100});
        is100ScrollFired = true;
    }
}

var internalHosts = [
    'shop.omni-biotic.com',
    'omni-biotic.com',
    'allergosan.com'
];

function handleLinkClick(e) {
// For auxclick, only proceed on middle-click (button === 1)
    if (e.type === 'auxclick' && e.button !== 1) return;

    //console.log('[outbound-tracking] clicked element:', e.target);

    var link = e.target.closest ? e.target.closest('a[href]') : null;
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href) return;

    if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
    if (href.indexOf('javascript:') === 0) return;
    if (href.charAt(0) === '#') return;

    var url;
    try {
        url = new URL(href, window.location.href);
    } catch (err) {
        return;
    }

    var hostname = url.hostname.replace(/^www\./, '');
    var isInternal = internalHosts.some(function (host) {
        return hostname === host.replace(/^www\./, '');
    });

    if (isInternal) return;

    var linkText = (link.textContent || '').trim().slice(0, 100);

    Shopify.analytics.publish("outboundClick", {
        link_url: url.href,
        link_domain: hostname,
        link_text: linkText
    });
}

document.addEventListener('click', handleLinkClick, true);
document.addEventListener('auxclick', handleLinkClick, true);

document.querySelector('.click-collect')?.addEventListener('click', event => {
    Shopify.analytics.publish("add_to_aponow_click");
});


(function () {
    var PARAM = '_jtsuid', COOKIE = 'jts-rw';
    var TARGET_HOSTS = ['allergosan.com','www.allergosan.com'];
    function readUserId() {
        var m = document.cookie.match('(?:^|; )' + COOKIE + '=([^;]*)');
        if (!m) return null;
        var raw = decodeURIComponent(m[1]);
        try { return JSON.parse(raw).u || null; } catch (e) { return null; } // jts-rw = {"u":"…"}
    }
    document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[href]'), uid = readUserId();
        if (!a || !uid) return;
        var url = new URL(a.href, location.href);
        if (TARGET_HOSTS.indexOf(url.hostname) === -1 || url.searchParams.get(PARAM) !== null) return;
        url.searchParams.append(PARAM, encodeURIComponent(uid));
        a.href = url.href;
    }, true);
})();
